module.exports = __webpack_public_path__ + "img/IMG_3450_L_Black_MockedUp.cf926fdf.jpg";